/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { Drawer, Form, Space, Input, Select, Button, message } from 'antd';
import emiter, {
	EVENT_CARRENTAL_EMPLOYEE_ADD,
	EVENT_CARRENTAL_EMPLOYEE_EDIT,
	EVENT_CARRENTAL_EMPLOYEE_VIEW,
	EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST, EVENT_CARRENTAL_EMPLOYEE_OPEN_MODAL,
} from '../../../../events';
import { createUser, getAllRole, getAllStore, editUser } from '../../../../hooks/carRental/employee';
import { encryptTextByAES } from '../../../../utils/encryption';
import useModalCloseConfirm from 'hooks/base/modalCloseConfirm';

interface PropsType {
	enums?: any;
}

const SPEmployeeAccountDrawer: React.FC<PropsType> = props => {
	const [mainForm] = Form.useForm();

	const { visible, onOpen, onClose, onOk, onEdited } = useModalCloseConfirm({});

	const [disabled, setDisabled] = useState(false);
	const [detailDrawerTitle, setDetailDrawerTitle] = useState('');
	const [roleList, setRoleList] = useState([]);
	const [storeList, setStoreList] = useState<any>([]);
	const [myData, setData] = useState<any>();
	const [numDisabled, setNumDisabled] = useState(false);

	const mainFormFields = {
		xingming: {
			name: 'user_name',
			label: '姓名',
			required: true,
			message: '请输入姓名',
			placeholder: '请输入',
		},
		shoujihao: {
			name: 'cell_encrypt',
			label: '手机号',
			required: true,
			message: '请输入正确手机号',
			placeholder: '请输入',
			pattern: new RegExp('^1[34578]\\d{9}$'),
		},
		suoshujuese: {
			name: 'role_code_list',
			label: '所属角色',
			required: true,
			message: '请选择所属角色',
			placeholder: '请选择',
		},
		suoshumendian: {
			name: 'store_code_list',
			label: '所属门店',
			required: false,
			message: '请选择所属门店',
			placeholder: '请选择',
			extra: '该员工仅可查看所选择门店信息',
		},
	};

	const checkExist = (list: any, currStore: any) => {
		const searchStore = list.filter((item: any) => item.store_code === currStore.store_code);
		if (!searchStore || !searchStore.length) {
			return true;
		}
		return false;
	};

	const mergeStoreList = (list: any) => {
		getAllStore().then((res: any) => {
			if (!list.length) {
				setStoreList(res.data);
				return;
			}
			if (res.data && res.data.length) {
				// 遇到相同的数据保留查询的数据
				const myList: any[] = [];
				list.forEach((item: any) => {
					if (checkExist(res.data, item)) {
						const newStore = { ...item, disabled: true };
						myList.push(newStore);
					}
				});
				setStoreList([...res.data, ...myList]);
			} else {
				list.forEach((item: any) => {
					item.disabled = true;
				});
				setStoreList(list);
			}
		});
	};

	// 查询详情
	const setForm = (data: any) => {
		// 合并storeList
		mergeStoreList(data?.store_list || []);
		const roleList: any = [];
		const storeList: any = [];
		if (data?.role_list && data?.role_list.length) {
			data.role_list.forEach((item: any) => {
				roleList.push(item.code);
			});
		}
		if (data?.store_list && data?.store_list.length) {
			data.store_list.forEach((item: any) => {
				storeList.push(item.store_code);
			});
		}
		mainForm.setFieldsValue({
			...data,
			role_code_list: roleList,
			store_code_list: storeList,
		});
		onOpen();
	};

	const onView = (data: any) => {
		setDetailDrawerTitle('员工详情');
		setDisabled(true);
		setForm(data);
	};

	const onEdit = (data: any) => {
		setDetailDrawerTitle('编辑员工');
		setForm(data);
		setData(data);
		setNumDisabled(true);
	};

	// 打开创建员工抽屉
	const addUser = () => {
		setDetailDrawerTitle('创建员工');
		onOpen();
		mainForm.resetFields();
		getAllStore().then((res: any) => {
			setStoreList(res.data);
		});
	};

	// 确认关闭
	const confimClose = () => {
		setDisabled(false);
		setNumDisabled(false);
		mainForm.resetFields();
	};

	// 确认添加
	const confirmAddUser = (callback: any) => {
		mainForm.validateFields().then((fieldsvalue: any) => {
			if (detailDrawerTitle === '编辑员工') {
				const params = {
					user_name: fieldsvalue.user_name,
					uid: myData.uid,
					role_code_list: fieldsvalue.role_code_list,
					store_code_list: fieldsvalue.store_code_list,
				};
				editUser(params).then((res: any) => {
					if (res.data) {
						message.success('修改成功');
						if (callback) callback();
						emiter.emit(EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST);
					}
				});
			} else {
				const params = {
					...fieldsvalue,
					cell_encrypt: encryptTextByAES(fieldsvalue.cell_encrypt),
				};
				createUser(params).then((res: any) => {
					if (res.data) {
						message.success('创建成功');
						if (callback) callback();
						emiter.emit(EVENT_CARRENTAL_EMPLOYEE_SEARCH_LIST);
					}
				});
			}
		});
	};

	// 查询所有角色
	const getRoles = (params?: any) => {
		getAllRole(params).then((res: any) => {
			setRoleList(res.data);
		});
	};

	const handleValuesChange = () => {
		onEdited();
	};

	useEffect(() => {
		getRoles();
		emiter.on(EVENT_CARRENTAL_EMPLOYEE_ADD, addUser);
		emiter.on(EVENT_CARRENTAL_EMPLOYEE_EDIT, onEdit);
		emiter.on(EVENT_CARRENTAL_EMPLOYEE_VIEW, onView);
		return () => {
			emiter.removeAllListeners(EVENT_CARRENTAL_EMPLOYEE_ADD)
			emiter.removeAllListeners(EVENT_CARRENTAL_EMPLOYEE_EDIT)
			emiter.removeAllListeners(EVENT_CARRENTAL_EMPLOYEE_VIEW)
		}
	}, []);

	return (
		<Drawer
			title={detailDrawerTitle}
			width="60%"
			onClose={() => onClose({ callback: confimClose })}
			open={visible}
			destroyOnClose
		>
			<Form form={mainForm} labelCol={{ span: 3 }} disabled={disabled} onValuesChange={handleValuesChange}>
				<Form.Item
					name={mainFormFields.xingming.name}
					label={mainFormFields.xingming.label}
					rules={[
						{
							required: mainFormFields.xingming.required,
							message: mainFormFields.xingming.message,
						},
					]}
				>
					<Input maxLength={10} placeholder={mainFormFields.xingming.placeholder} />
				</Form.Item>
				<Form.Item
					name={mainFormFields.shoujihao.name}
					label={mainFormFields.shoujihao.label}
					rules={[
						{
							required: mainFormFields.shoujihao.required,
							message: mainFormFields.shoujihao.message,
							// pattern: mainFormFields.shoujihao.pattern,
						},
					]}
				>
					<Input disabled={numDisabled || disabled} placeholder={mainFormFields.shoujihao.placeholder} />
				</Form.Item>
				<Form.Item
					name={mainFormFields.suoshujuese.name}
					label={mainFormFields.suoshujuese.label}
					rules={[
						{
							required: mainFormFields.suoshujuese.required,
							message: mainFormFields.suoshujuese.message,
						},
					]}
				>
					<Select mode="multiple" showSearch={false} placeholder={mainFormFields.suoshujuese.placeholder}>
						{roleList &&
							roleList.map((item: any) => (
								<Select.Option value={item.code} key={item.code}>
									{item.name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
				<Form.Item
					name={mainFormFields.suoshumendian.name}
					label={mainFormFields.suoshumendian.label}
					rules={[
						{
							required: mainFormFields.suoshumendian.required,
							message: mainFormFields.suoshumendian.message,
						},
					]}
					extra={mainFormFields.suoshumendian.extra}
				>
					<Select mode="multiple" showSearch={false} placeholder={mainFormFields.suoshumendian.placeholder}>
						{storeList &&
							storeList.map((item: any) => (
								<Select.Option value={item.store_code} key={item.store_code} disabled={item.disabled}>
									{item.store_name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
			</Form>
			<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
				<Space>
					<Button onClick={() => onClose({ callback: confimClose })}>取消</Button>
					{detailDrawerTitle === '员工详情' ? null : (
						<Button type="primary" onClick={() => onOk({ callback: confirmAddUser })}>
							确认
						</Button>
					)}
				</Space>
			</div>
		</Drawer>
	);
};

export default SPEmployeeAccountDrawer;
